import { Client } from './Api';
import getSecuredAxiosInstance, { ExtendedAxios } from '../SecuredAxios';
import getSecuredUMATokenAxiosInstance from '../SecuredUMATokenAxios';
import ConfigUtility from 'Core/ConfigUtility';
import { cloneDeep } from 'lodash';


export class SecuredAPMProxyClient extends Client {
  public axiosInstance: ExtendedAxios;

  public get DisableToken(): boolean | undefined {
    return this.axiosInstance.disableToken;
  }

  public set DisableToken(newValue: boolean | undefined) {
    this.axiosInstance.disableToken = newValue;
  }

  public get handleGeneralError(): boolean | undefined {
    return this.axiosInstance.handleGeneralError;
  }

  public set handleGeneralError(newValue: boolean | undefined) {
    this.axiosInstance.handleGeneralError = newValue;
  }

  public get handleSecurityError(): boolean | undefined {
    return this.axiosInstance.handleSecurityError;
  }

  public set handleSecurityError(newValue: boolean | undefined) {
    this.axiosInstance.handleSecurityError = newValue;
  }

  public get showLoading(): boolean | undefined {
    return this.axiosInstance.showLoading;
  }

  public set showLoading(newValue: boolean | undefined) {
    this.axiosInstance.showLoading = newValue;
  }

  constructor() {
    const Config = ConfigUtility.getSync()!;
    
    // This creates a new instance for this client
    const axios = getSecuredUMATokenAxiosInstance();
    super(Config?.APMProxyApiBaseUrl, axios);
    this.axiosInstance = axios;
    this.axiosInstance.baseUrlConfigName = "APMProxyApiBaseUrl";
    
  }
}
